import React, { useState } from "react";
import { Container, Button, Tabs, Tab, Card, CardContent, Typography, Stack, IconButton } from "@mui/material";
import { Edit, Visibility, Delete, Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import  EmailTemplatePage from "../Templates/email-template";
import EmailTemplateModal from "./EmailTemplateModal";
const TemplatesPage = () => {
    const [tab, setTab] = useState("email");
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);

    const templates = [
        { id: 1, name: "Invitation", used: 53 },
        { id: 2, name: "Reminder", used: 54 },
        { id: 3, name: "Interview Completed", used: 55 },
    ];

    return (
        <Container maxWidth="md" sx={{ mt: 4 }}>
            <Typography variant="h5" fontWeight="bold">
                Email, SMS & WhatsApp Templates
            </Typography>
            <Typography color="gray" sx={{ mb: 2 }}>
                Create and edit Email and SMS templates to use them on your candidate notifications.
            </Typography>

            {/* Tabs for Email, SMS, WhatsApp */}
            <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} sx={{ mb: 2 }}>
                <Tab label="Email" value="email" />
                <Tab label="SMS" value="sms" />
                <Tab label="WhatsApp" value="whatsapp" />
            </Tabs>

            {/* Create Template Button */}
            <Button
                variant="contained"
                sx={{ mb: 2, backgroundColor: "#1976D2" }}
                startIcon={<Add />}
                onClick={() => setModalOpen(true)}
            >
                Create a {tab} template
            </Button>

            {/* Template Cards */}
            {templates.map((template) => (
                <Card key={template.id} sx={{ mb: 2 }}>
                    <CardContent>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <img src="/email-icon.png" alt="Template Icon" width={40} height={40} />
                                <div>
                                    <Typography fontWeight="bold">{template.name}</Typography>
                                    <Typography variant="body2" color="green">Used in {template.used} positions</Typography>
                                </div>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <IconButton><Visibility /></IconButton>
                                <IconButton><Edit onClick={() => navigate("/templates/edit")} /></IconButton>
                                <IconButton><Delete color="error" /></IconButton>
                            </Stack>
                        </Stack>
                    </CardContent>
                </Card>
            ))}

            {/* Edit Templates Button */}
            <Button
                variant="contained"
                sx={{ background: "#e0e0e0", color: "#404040", textTransform: "none", borderRadius: "6px", mt: 1 }}
                onClick={() => navigate("/templates")}
            >
                Edit Templates
            </Button>

            {/* Email Template Modal */}
            <EmailTemplatePage open={modalOpen} onClose={() => setModalOpen(false)} />
             {/* <EmailTemplateModal open={modalOpen  } onClose={() => setModalOpen(false)}/> */}
        </Container>
    );
};

export default TemplatesPage;
